import React from 'react'

const CompanyLink = ({ relatedLinks, children }) => {
    /**
     * @param {{link: string, text: string}[]}relatedLinks
     */
    const getCompanyLink = (relatedLinks) => {
        if (relatedLinks) {
            const companyLink = relatedLinks.find(relatedLink => !relatedLink.link.includes('google.com'))

            if (companyLink) return companyLink.link
        }
    }

    const companyLink = getCompanyLink(relatedLinks)
    if (companyLink) {
        return (
            <a
                className="mt-2"
                target="_blank"
                rel="noopener noreferrer"
                href={companyLink}>
                {children}
            </a>
        )
    } else return (
        <React.Fragment>
            {children}
        </React.Fragment>
    )
}

export default CompanyLink


// WEBPACK FOOTER //
// ./src/routes/authenticated/JobSearch/components/CompanyLink.js